import firebase from 'firebase/app';
import 'firebase/auth';

// The configuration below is not sensitive data. You can serenely add your config here
const config = {
  apiKey: 'AIzaSyDT_jUJPML1tXauxtt3Hg_lFqQifIFih9A',
  authDomain: 'testkits-f718b.firebaseapp.com',
  databaseURL: 'https://testkits-f718b.firebaseio.com',
  projectId: 'testkits-f718b',
  storageBucket: 'testkits-f718b.appspot.com',
  messagingSenderId: '118319569593',
  appId: '1:118319569593:web:3f108dc305014514fe9968',
  measurementId: 'G-8NL8GDY7CW',
};
firebase.initializeApp(config);
